/*
 * @Author: Tina Huang
 * @Date: 2025-02-06 15:36:22
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-24 15:24:55
 * @Description:
 */
type QA = {
  id: string
  created_at: string
  title: string
  description?: string
  created_by: string
  answer?: string
  type: string // 新手疑问，高阶运用，更新介绍，基础操作
  level: number
  help?: boolean // 是否在帮助中心显示
  help_title?: string
  link?: string
}

export const TypeTag: any = {
  新手疑问: 'magenta',
  新手指南: '#cd201f',
  基础操作: 'geekblue',
  拓展操作: 'green',
}

export const qaList: QA[] = [
  {
    id: '1876018c38ee800da218e540c08bc7b2',
    title: '新手入门｜Notion是功能强大的工具，可以帮助组织笔记、任务管理、日程安排等',
    description: '',
    type: '新手指南',
    created_at: '1737872640000',
    created_by: '@阿汪同学',
    answer: '1',
    level: 1,
    help: true,
    help_title: '快速了解Notion',
  },
  {
    id: '1996018c38ee8064aa0fd28c917d6f55',
    title: '如何快速了解FlowUs？',
    description: '',
    type: '新手指南',
    created_at: '1739427720000',
    created_by: '@阿汪同学',
    level: 1,
    answer: '1',
    help: true,
    link: 'https://flowus.cn/share/19cc8990-ac51-43c9-9144-36cb7c09f9c9',
  },
  {
    id: '19e6018c38ee8001ac59e4c70fb69738',
    title: '什么是数据库（Database）？！',
    description: '',
    type: '新手指南',
    created_at: '1739841840000',
    created_by: '@阿汪同学',
    level: 3,
    answer: '',
  },
  {
    id: '1996018c38ee80148364d381080efb6d',
    title: 'Notion｜如何使用Notion Web Clipper快速剪藏网页？',
    description: '',
    type: '拓展操作',
    created_at: '1739428440000',
    created_by: '@阿汪同学',
    level: 2,
    answer: '1',
  },
  {
    id: '1946018c38ee80e98316d9dd7ac18825',
    title: 'Notion｜如何使用他人的模版以及将自己的页面发布为公开页面？',
    description: '',
    type: '新手疑问',
    created_at: '1738993920000',
    created_by: '@阿汪同学',
    level: 1,
    answer: '1',
  },
  {
    id: '1876018c38ee807b9055f0d00e65a240',
    title: 'Notion｜🔥 如何在 Notion 内创建重复事件（Repeat Event）',
    description: '',
    type: '基础操作',
    created_at: '1737882360000',
    created_by: '@阿汪同学',
    level: 3,
    answer: '1',
  },
  {
    id: '1876018c38ee80a1a8dcc28349e6013d',
    title: 'Notion｜如何让Notion内日历从周一开始？',
    description: '',
    type: '新手疑问',
    created_at: '1737878400000',
    created_by: '@阿汪同学',
    level: 1,
    answer: '1',
  },
  {
    id: '1876018c38ee803fb6a9fa62935c501b',
    title: 'Notion｜如何切换Notion客户端语言？',
    description: '',
    type: '新手疑问',
    created_at: '1737878340000',
    created_by: '@阿汪同学',
    answer: '1',
    level: 1,
  },
  {
    id: '1856018c38ee809f8dccccb2a68c6760',
    title: 'Notion｜如何下载软件以及注册账号？',
    description: '',
    type: '新手疑问',
    created_at: '1737704280000',
    created_by: '@阿汪同学',
    answer: '1',
    level: 1,
  },
]
